// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"228":"37d96719","541":"f021b797"}[chunkId] + ".chunk.js";
};